import React from "react";
import { ConfigProvider,Tabs } from "antd";

interface TabItem {
  label: string | React.ReactNode;
  key: string;
  disabled?: boolean;
  children: React.ReactNode;
}

interface TabsComponentProps {
  tabsData: TabItem[];
  defaultActiveKey?: string;
  activeKey: string;
  tabPosition?: "top" | "bottom" | "left" | "right";
  height?: number | string;
  onChange: (key: string) => void;
}

const TabsComponent: React.FC<TabsComponentProps> = ({
  tabsData,
  defaultActiveKey = "0",
  tabPosition = "left",
  height = 450,
  activeKey="",
  onChange
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#000", 
        },
      }}
      >
      <Tabs
        defaultActiveKey={defaultActiveKey}
        activeKey={activeKey}
        tabPosition={tabPosition}
        // type="card"
        //style={{ height }}
        className="custom-tabs"
        items={tabsData}
        onChange={onChange}
      />
  </ConfigProvider>
  );
};

export default TabsComponent;
